module.exports = __webpack_public_path__ + "img/icon10.133ce968.png";